import React from "react";
import { Link } from "react-router-dom";

import AccountContext from "./AccountContext";
import { firebase } from "../firebase";
import { getMyAccount } from "../firebase/firestore";

const accountScope = Component =>
  class AccountScope extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        account: null,
        error: false
      };
    }

    componentDidUpdate() {
      if (this.state.account === null && firebase.auth.currentUser !== null) {
        getMyAccount(
          firebase.auth.currentUser.uid,
          (id, name, admin) => {
            this.setState({
              account: { id: id, name: name, admin: admin },
              error: false
            });
          },
          error => {
            this.setState({ account: null, error: true });
          }
        );
      }
    }

    render() {
      const { account, error } = this.state;

      return (
        <AccountContext.Provider value={account}>
          <Component />
        </AccountContext.Provider>
      );
    }
  };

export default accountScope;



// WEBPACK FOOTER //
// ./src/utils/AccountScope.js